export default __webpack_public_path__ + "static/media/fu-shin-street.958097ad.jpg";